import { render } from "./DarkSwtichBtn.vue?vue&type=template&id=1a2f5956&ts=true"
import script from "./DarkSwtichBtn.vue?vue&type=script&lang=ts"
export * from "./DarkSwtichBtn.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Layouts/TopHeader/DarkSwtichBtn.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a2f5956"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a2f5956', __exports__)) {
    api.reload('1a2f5956', __exports__)
  }
  
  module.hot.accept("./DarkSwtichBtn.vue?vue&type=template&id=1a2f5956&ts=true", () => {
    api.rerender('1a2f5956', render)
  })

}


export default __exports__